// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jI-z","twoColumnImage":"kI-z"};